import axios from "axios";
import { notification, message as Msg } from "ant-design-vue";
class Http {
  constructor(config) {
    this.config = config || {
      timeout: 30 * 1000,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    };
  }

  interceptors(instance) {
    /**
     * 请求拦截器
     */
    instance.interceptors.request.use(
      (config) => {
        const token = sessionStorage.getItem("USER_TOKEN");
        if (token) {
          config.headers["access-Token"] = token;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    /** 响应拦截 */
    instance.interceptors.response.use(
      (response) => {
        // if (response.data.code === 401) {
        //   return;
        // }
        if (response.config.resultRank == "response") {
          return Promise.resolve(response);
        } else if (response.config.resultRank == "response.data") {
          return Promise.resolve(response.data);
        } else if (response.config.responseType == "blob") {
          // 如果是二进制数据的话,这里做特殊处理
          const link = document.createElement("a");
          let blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          let dis = response.headers["content-disposition"];
          if (dis) {
            let fileName = dis.split("attachment;filename=")[1];
            link.download = decodeURIComponent(fileName); //下载后文件名
          }
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          return Promise.resolve(response);
        }
      },
      (error) => {
        if (error.response) {
          const data = error.response.data;
          if (error.response.status === 403) {
            notification.error({
              message: "无权限访问",
              description: data.message,
            });
          } else if (error.response.status === 401) {
            return Promise.reject("登录已过期！");
          } else if (error.response.status === 413) {
            console.log("response.config", response.config);
            // if(Content-Type)
            Msg.error("文件上传失败,文件过大");
            return Promise.reject("文件上传失败,文件过大");
          } else {
            Msg.error("网络连接失败，请检查网络");
            return Promise.reject("网络连接失败");
          }
        } else {
          let { message } = error;
          if (message === "Network Error") {
            message = "网络连接失败，请检查网络";
          }
          if (message.includes("timeout")) {
            message = "查询数据异常或网络异常，请刷新页面";
          }
          if (message.includes("Request failed with status code")) {
            const code = message.substr(message.length - 3);
            message = "接口" + code + "异常";
          }
          Msg.error(message);
          return Promise.reject(error);
        }
      }
    );
  }

  request(options) {
    const instance = axios.create();
    const requestOptions = Object.assign({}, this.config, options);
    this.interceptors(instance);
    return instance(requestOptions);
  }
}

const http = new Http();
export default http;
